import type { SelectChangeEvent } from '@mui/material';
import Grid from '@mui/material/Grid';
import { SecondaryMenuItemTitle } from './SecondaryMenuTitles';
import { SelectInputColumn } from './SelectInputColumn.tsx';
import type { CSSProperties } from 'react';

type SelectInputTwoColProps = {
  label?: string;
  menuItems: string[];
  isMultiple?: boolean;
  onChange: (event: SelectChangeEvent<string[]>) => void;
  testId: string;
  value?: string[];
  variant?: 'standard' | 'outlined';
  maxWidth?: string;
  customSelectStyle?: CSSProperties;
};

export const SelectInputTwoCol = ({
  menuItems,
  onChange,
  testId,
  label = '',
  value = [],
  isMultiple = false,
  variant,
  maxWidth = '130px',
  customSelectStyle,
}: SelectInputTwoColProps) => {
  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const selectedValue = event.target.value;
    // For multiple select, ensure we're always working with arrays
    const newValue = typeof selectedValue === 'string' ? [selectedValue] : selectedValue;

    onChange({
      ...event,
      target: {
        ...event.target,
        name: 'drop-down-select',
        value: newValue,
      },
    } as SelectChangeEvent<string[]>);
  };

  return (
    <Grid data-testid={testId} container alignItems="center" justifyContent="space-between" gap={1}>
      <Grid item>
        <SecondaryMenuItemTitle>{label}</SecondaryMenuItemTitle>
      </Grid>

      <SelectInputColumn
        variant={variant}
        menuItems={menuItems}
        handleChange={handleChange}
        value={value}
        isMultiple={isMultiple}
        maxWidth={maxWidth}
        customSelectStyle={customSelectStyle}
      />
    </Grid>
  );
};
